import { gql } from '@apollo/client';

const ProductInfoPublic = gql`
  fragment ProductInfoPublic on ProductPublic {
    id
    name
    price
    description
    sku
    defaultSubscriptionRetaner
    productCategories {
      id
      name
    }
    featuredImage
    productRenewalInterval {
      id
      name
    }
    productFeatures {
      id
      text
    }
    productImages {
      id
      imageUrl
    }
    productType
    planSubscription {
      id
      name
    }
    planProducts {
      id
      overridePrice
      price
    }
    createdAt
    updatedAt
  }
`;

export default ProductInfoPublic;
